module.exports = __webpack_public_path__ + "static/virgin-card-d6d96ad808ad280e820ac2ef025dedd8.png";